/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4 3v8.75H.75a.75.75 0 0 0 0 1.5H4V21c0 1.6569 1.3431 3 3 3h7c1.6569 0 3-1.3431 3-3v-7.75h4.132l-1.2197 1.2197a.75.75 0 0 0 1.0607 1.0606L24.0033 12.5 20.973 9.4697a.75.75 0 0 0-1.0607 1.0606L21.132 11.75H17V3c0-1.6568-1.3431-3-3-3H7C5.3431 0 4 1.3432 4 3Zm10-1.5H7c-.8284 0-1.5.6716-1.5 1.5v8.75h4.75a.75.75 0 0 1 0 1.5H5.5V21c0 .8284.6716 1.5 1.5 1.5h7c.8284 0 1.5-.6716 1.5-1.5V3c0-.8284-.6716-1.5-1.5-1.5Z"
    clipRule="evenodd"
  />,
  'MenuGateway'
);
